export default "__VITE_ASSET__BC8sDyG6__"